import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { ChangeRequest, ChangeRequestInboxItem, ChangeRequestWorkflowHistory, SubmitChangeRequest } from '#models';

@Injectable({ providedIn: 'root' })
export class ChangeRequestService {
    private _http = inject(HttpClient);
    private _base = `${environment.apiBaseUrl}/v1/remediations`;
    private _inboxUrl = `${environment.apiBaseUrl}/v1/change-requests/inbox`;

    getInbox(): Observable<ChangeRequestInboxItem[]> {
        return this._http.get<ChangeRequestInboxItem[]>(this._inboxUrl);
    }

    getByRemediation(remediationId: string): Observable<ChangeRequest[]> {
        return this._http.get<ChangeRequest[]>(`${this._base}/${remediationId}/change-requests`);
    }

    submit(dto: SubmitChangeRequest): Observable<ChangeRequest> {
        return this._http.post<ChangeRequest>(
            `${this._base}/${dto.remediationId}/change-requests`,
            dto
        );
    }

    approve(remediationId: string, changeRequestId: string): Observable<ChangeRequest> {
        return this._http.post<ChangeRequest>(
            `${this._base}/${remediationId}/change-requests/${changeRequestId}/approve`,
            {}
        );
    }

    setPending(remediationId: string, changeRequestId: string): Observable<ChangeRequest> {
        return this._http.post<ChangeRequest>(
            `${this._base}/${remediationId}/change-requests/${changeRequestId}/pending`,
            {}
        );
    }

    reject(remediationId: string, changeRequestId: string): Observable<ChangeRequest> {
        return this._http.post<ChangeRequest>(
            `${this._base}/${remediationId}/change-requests/${changeRequestId}/reject`,
            {}
        );
    }

    reassign(remediationId: string, changeRequestId: string, newApproverUserId: string): Observable<ChangeRequest> {
        return this._http.post<ChangeRequest>(
            `${this._base}/${remediationId}/change-requests/${changeRequestId}/reassign`,
            { newApproverUserId }
        );
    }

    getWorkflowHistory(remediationId: string, changeRequestId: string): Observable<ChangeRequestWorkflowHistory[]> {
        return this._http.get<ChangeRequestWorkflowHistory[]>(
            `${this._base}/${remediationId}/change-requests/${changeRequestId}/history`
        );
    }
}
